import {CatalogueFeatureTreeNode} from './buildFeatureTreesFromCatalogueKeys';

export const expandSelectedFeatureValues = (
  selected: string[],
  featureTrees: CatalogueFeatureTreeNode[]
): string[] => {
  const featuresByValue = buildFeatureValueMap(featureTrees);
  const expanded = selected.flatMap((value) => {
    const feature = featuresByValue.get(value);

    return feature ? getLeafFeatureValues(feature) : [value];
  });

  return [...new Set(expanded)];
};

const buildFeatureValueMap = (featureTrees: CatalogueFeatureTreeNode[]) => {
  const featuresByValue = new Map<string, CatalogueFeatureTreeNode>();

  featureTrees.forEach((feature) => addFeatureToMap(feature, featuresByValue));

  return featuresByValue;
};

const addFeatureToMap = (
  feature: CatalogueFeatureTreeNode,
  featuresByValue: Map<string, CatalogueFeatureTreeNode>
) => {
  featuresByValue.set(feature.value, feature);
  feature.children.forEach((child) => addFeatureToMap(child, featuresByValue));
};

const getLeafFeatureValues = (feature: CatalogueFeatureTreeNode): string[] =>
  feature.children.length ? feature.children.flatMap(getLeafFeatureValues) : [feature.value];
